import SectionCell from "../../cell"
import { findSelectOptionName } from "../../../../utils"
import {
  LOAN_PURPOSE_OPTIONS,
  LOAN_TERM_OPTIONS,
  ARM_TERM_OPTIONS,
  LOAN_TYPE_OPTIONS,
  PROPERTY_TYPE_OPTIONS,
  RESIDENCY_TYPE_OPTIONS,
  VA_FUNDING_FEE_OPTIONS
} from "../../../../constants"

interface Props {
  label:
    | "Loan purpose"
    | "Property type"
    | "Residency type"
    | "Loan type"
    | "Loan term"
    | "Arm term"
    | "Property usage"
    | "VA Funding Fee"
  value: number | string
}

const OptionValueToNama = ({ label, value }: Props) => {
  const options = {
    "Loan purpose": LOAN_PURPOSE_OPTIONS,
    "Property type": PROPERTY_TYPE_OPTIONS,
    "Residency type": RESIDENCY_TYPE_OPTIONS,
    "Loan type": LOAN_TYPE_OPTIONS,
    "Loan term": LOAN_TERM_OPTIONS,
    "Arm term": ARM_TERM_OPTIONS,
    "Property usage": RESIDENCY_TYPE_OPTIONS,
    "VA Funding Fee": VA_FUNDING_FEE_OPTIONS
  }

  return (
    <SectionCell
      label={label}
      value={findSelectOptionName(value + "", options[label])}
      className="!pt-0"
    />
  )
}

export default OptionValueToNama
